import React from "react";
import { Event } from "types";
import { ShowResourceNames } from "../ShowResourceNames";
import { GuideName } from "./GuideName";

interface GuideListProps {
    event: Event;
    showOnlyCount: boolean;
}

const warningMessage =
    "There are no active reservations in this event. You could unassign the guides(s) to make them available to other events";

export const GuideList = ({ event, showOnlyCount = false }: GuideListProps) => {
    const guides = event?.guides ?? [];
    const guidesCount = guides.length;

    const guideNames = guides.map((eventGuide) => {
        return <GuideName key={eventGuide.guide.id} event={event} eventGuide={eventGuide} />;
    });

    const hasReservation = event?.quantity?.reserved > 0;
    const totalGuideCount = guides?.length ?? 0;
    const hasGuidesAssigned = totalGuideCount > 0;
    const showWarning = !hasReservation && hasGuidesAssigned;
    const warning = showWarning ? warningMessage : null;

    return (
        <ShowResourceNames content={guideNames} count={guidesCount} warning={warning} showOnlyCount={showOnlyCount} />
    );
};
